import React from 'react';
import { Redirect, Route, Switch, generatePath } from 'react-router-dom';
import lazyload from '@/utils/lazyload';
import { defaultRouteKey } from './config';

/**
 * 以 key 为维度缓存 loadable 组件。
 * 必须用 key（而不是节点对象 / 组件引用）做键：权限刷新时 filterByPermission
 * 会产生全新的节点对象，若用对象做键会导致组件类型变化、整页重挂载。
 */
const pageCache = new Map();
export function getPage(node) {
  const cached = pageCache.get(node.key);

  if (cached) {
    return cached;
  }

  const page = lazyload(node.component);
  pageCache.set(node.key, page);
  return page;
}
const NotFound = getPage({
  key: 'exception/403',
  component: () => import('@/pages/exception/403')
});
export default function RouteOutlet({
  routes
}) {
  const pages = routes.filter(item => !!item.node.component);
  const containers = routes.filter(item => item.isContainer && !!item.node.redirectTo);
  const fallback = pages.find(item => item.node.key === defaultRouteKey) ?? pages[0];
  return /*#__PURE__*/React.createElement(Switch, null, pages.map(item => {
    const Page = getPage(item.node);
    return /*#__PURE__*/React.createElement(Route, {
      key: item.node.key,
      exact: true,
      path: item.pathTemplate,
      render: props =>
      /*#__PURE__*/
      // 参数变化（例如切换 tenant）时强制重挂载页面，确保重新取数
      React.createElement(Page, {
        key: JSON.stringify(props.match.params)
      })
    });
  }), containers.map(item => /*#__PURE__*/React.createElement(Route, {
    key: item.node.key,
    exact: true,
    path: item.pathTemplate,
    render: props => {
      const target = routes.find(route => route.node.key === item.node.redirectTo);

      if (!target) {
        // redirectTo 指向了不存在的 key: 不能静默白屏, 交给 403 兜底页暴露问题
        return /*#__PURE__*/React.createElement(NotFound, null);
      }

      return /*#__PURE__*/React.createElement(Redirect, {
        to: generatePath(target.pathTemplate, props.match.params)
      });
    }
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: fallback ? generatePath(fallback.pathTemplate, {}) : '/403'
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: NotFound
  }));
}